/** A mapping of website sizes to their respective monthly subscription price */
const subscriptionAmountMapping: Record<number, Record<number, number>> = {
	10: {
		500: 38,
		400: 36,
		300: 34,
		200: 32,
		150: 29,
		125: 27,
		100: 25,
		75: 22,
		50: 19,
		25: 15,
	},
	20: {
		5000: 79,
		2500: 74,
		1000: 69,
		500: 64,
		300: 58,
		200: 52,
		125: 46,
		75: 38,
		50: 30,
		25: 22,
	},
	21: {
		5000: 82,
		2500: 76,
		1000: 70,
	},
	30: {
		1000: 89,
		900: 84,
		800: 79,
		700: 74,
		600: 69,
		500: 64,
		400: 61,
		300: 57,
		200: 53,
		150: 48,
		125: 45,
		100: 41,
		75: 36,
		50: 29,
		25: 21,
	},
};

export default subscriptionAmountMapping;
